import { LinkProps as NextLinkProps } from 'next/link';
import { ComponentPropsWithoutRef, ElementType, Ref } from 'react';
import ArrowLeft from '~/icons/iconography/arrow/left.svg';
import ArrowRight from '~/icons/iconography/arrow/right.svg';
import { StyledLink } from '~/shared/styles/Link';
import { StyledIcon, StyledLinkWrapper } from './styled';

export type LinkProps = Omit<NextLinkProps, 'as' | 'href'> &
    Omit<ComponentPropsWithoutRef<'a'>, keyof NextLinkProps> & {
        href?: NextLinkProps['href'];
        as?: ElementType;
        /**
         * Should link be shown with the arrow icon
         */
        animation?: 'default' | 'none' | 'reverse' | 'static';
        fullWidth?: boolean;
        multipleElements?: boolean;
        withIcon?: boolean;
        displayFlex?: boolean;
        iconLeft?: boolean;
        customIcon?: React.ReactNode;
        ref?: Ref<HTMLAnchorElement>;
    };

export const Link = ({
    animation = 'default',
    children,
    displayFlex = false,
    fullWidth = false,
    multipleElements = false,
    withIcon = false,
    iconLeft = false,
    customIcon,
    href,
    as,
    ref,
    prefetch = false,
    ...rest
}: LinkProps) => {
    const linkAnimation = withIcon ? 'none' : animation;
    const wrapperProps = { ...rest, ...(as ? { as: as as never } : {}) };

    return (
        <StyledLinkWrapper
            href={href ?? '#'}
            fullWidth={fullWidth}
            iconLeft={iconLeft}
            prefetch={prefetch}
            ref={ref}
            {...wrapperProps}
        >
            <StyledLink
                animation={linkAnimation}
                displayFlex={displayFlex}
                fullWidth={fullWidth}
                multipleElements={multipleElements}
            >
                {withIcon && iconLeft ? (
                    <StyledIcon fullWidth={fullWidth} iconLeft={iconLeft}>
                        {customIcon ? customIcon : <ArrowLeft />}
                    </StyledIcon>
                ) : null}

                {children}

                {withIcon && !iconLeft ? (
                    <StyledIcon fullWidth={fullWidth} iconLeft={iconLeft}>
                        {customIcon ? customIcon : <ArrowRight />}
                    </StyledIcon>
                ) : null}
            </StyledLink>
        </StyledLinkWrapper>
    );
};
